var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saas-section"},[(_vm.block.title)?_c('div',{staticClass:"saas-section__title"},[_c('h2',{staticClass:"saas-striped-title"},[_vm._v(_vm._s(_vm.block.title))])]):_vm._e(),_vm._v(" "),_c('PageTimeline',{attrs:{"items":_vm.block.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }